export default {"src":"/_next/static/media/MBLY.4b9be8b6.svg","height":18,"width":18};